import type * as React from 'react';

import { Heading, Panel, PanelBody } from '@gitbook/spine-react';

import { isSiteOnlyCustomization, type SitesCustomizationPanelProps } from '../types';
import { FontSettings, MonoFontSettings } from './Font';
import { ThemeCornersSettings } from './ThemeCornersSettings';
import { ThemeDepthSettings } from './ThemeDepthSettings';
import { ThemeIconsSettings } from './ThemeIconsSettings';
import { ThemeLinksStyleSettings } from './ThemeLinksStyleSettings';

/**
 * Handle the font and theme corners settings.
 */
export function StylingPanel(props: SitesCustomizationPanelProps): React.ReactElement {
    return (
        <Panel>
            <Heading>Site styles</Heading>
            <PanelBody>
                {isSiteOnlyCustomization(props) ? (
                    <>
                        <FontSettings {...props} />
                        <MonoFontSettings {...props} />
                    </>
                ) : null}
                <ThemeIconsSettings {...props} />
                <ThemeCornersSettings {...props} />
                <ThemeDepthSettings {...props} />
                <ThemeLinksStyleSettings {...props} />
            </PanelBody>
        </Panel>
    );
}
